<template><section>
<h1>Modal</h1>
<p>Use Bootstrap's JavaScript modal plugin to add dialogs to your site for lightboxes, user notifications, or completely custom content.</p>
<demo clz="">
                    <bs-button @click="modal1=true" ref="modal1Trigger">Open modal</bs-button>
<bs-modal v-model="modal1" title="Modal title" :trigger="$refs.modal1Trigger">
  <p>Woohoo, you're reading this text in a modal!</p>
  <template slot="footer">
    <bs-button type="secondary" @click="modal1=false">Close</bs-button>
    <bs-button @click="modal1=false">SaveChanges</bs-button>
  </template>
</bs-modal>

                    <template slot="desp"><p>Modal components</p>
</template>
                    <template slot="source">
                    <pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">bs-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"modal1=true"</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">"modal1Trigger"</span>&gt;</span>Open modal<span class="hljs-tag">&lt;/<span class="hljs-name">bs-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">bs-modal</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"modal1"</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Modal title"</span> <span class="hljs-attr">:trigger</span>=<span class="hljs-string">"$refs.modal1Trigger"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>Woohoo, you're reading this text in a modal!<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"footer"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">bs-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"secondary"</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"modal1=false"</span>&gt;</span>Close<span class="hljs-tag">&lt;/<span class="hljs-name">bs-button</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">bs-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"modal1=false"</span>&gt;</span>SaveChanges<span class="hljs-tag">&lt;/<span class="hljs-name">bs-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">bs-modal</span>&gt;</span>
</code></pre>
</template></demo>
<component-doc tabs="props slots events">
                    
                    <table>
<thead>
<tr>
<th>Key</th>
<th>Type</th>
<th>Required</th>
<th>Default</th>
<th>Description</th>
<th>Remark</th>
</tr>
</thead>
<tbody>
<tr>
<td>size</td>
<td>String</td>
<td>false</td>
<td></td>
<td>Avaliable values: <code v-pre="">large</code>, 'small'</td>
<td></td>
</tr>
<tr>
<td>title</td>
<td>String</td>
<td>false</td>
<td></td>
<td>modal head title</td>
<td></td>
</tr>
<tr>
<td>value</td>
<td>Boolean</td>
<td>false</td>
<td>false</td>
<td><code v-pre="">v-model</code> binding</td>
<td></td>
</tr>
<tr>
<td>role</td>
<td>String</td>
<td>false</td>
<td></td>
<td>modal role</td>
<td></td>
</tr>
<tr>
<td>ariaLabel</td>
<td>String</td>
<td>false</td>
<td></td>
<td>modal aria-labelledby</td>
<td></td>
</tr>
<tr>
<td>backdrop</td>
<td>Boolean</td>
<td>false</td>
<td>true</td>
<td>Includes a modal-backdrop element. Alternatively, specify static for a backdrop which doesn't close the modal on click.</td>
<td></td>
</tr>
<tr>
<td>keyboard</td>
<td>Boolean</td>
<td>false</td>
<td>true</td>
<td>Closes the modal when escape key is pressed</td>
<td></td>
</tr>
<tr>
<td>focus</td>
<td>Boolean</td>
<td>false</td>
<td>true</td>
<td>Puts the focus on the modal when initialized.</td>
<td>Need to fix</td>
</tr>
<tr>
<td>trigger</td>
<td>Object</td>
<td>false</td>
<td>null</td>
<td>Dom element to trigger modal show</td>
<td></td>
</tr>
</tbody>
</table>
<table>
<thead>
<tr>
<th>Name</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td>default</td>
<td>Modal content</td>
</tr>
<tr>
<td>title</td>
<td>Modal title</td>
</tr>
<tr>
<td>footer</td>
<td>Modal foooter</td>
</tr>
</tbody>
</table>
<table>
<thead>
<tr>
<th>Name</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td>before-show</td>
<td>Trigged before modal show</td>
</tr>
<tr>
<td>shown</td>
<td>Trigged after modal shown</td>
</tr>
<tr>
<td>close</td>
<td>Trigged after click close icon</td>
</tr>
<tr>
<td>before-hide</td>
<td>Trigged before modal hide</td>
</tr>
<tr>
<td>hidden</td>
<td>Trigged after modal hidden</td>
</tr>
<tr>
<td>backdrop</td>
<td>Trigged when click backdroped</td>
</tr>
<tr>
<td>escape</td>
<td>Trigged when escape keydown</td>
</tr>
</tbody>
</table>
</component-doc>
</section></template>

<script>
export default {
  data () {
    return {
      modal1: false
    }
  }
}
</script>


// WEBPACK FOOTER //
// example/views/components/Modal.vue?df79b3fa